/**
 * Minimal Server-Sent Events parser. The queue stream is read with `fetch` instead of the browser's
 * `EventSource` because `EventSource` cannot send an `Authorization` header, and we do not want the
 * access token in a URL where it would end up in logs (spec §10.1).
 */

export interface SseEvent {
  readonly event: string;
  readonly data: string;
}

/**
 * Returns a function you feed decoded text chunks to; it calls `onEvent` for every complete event.
 * Comment lines (`: keepalive`) are ignored. Chunks may split events or lines anywhere.
 */
export function createSseParser(onEvent: (event: SseEvent) => void): (chunk: string) => void {
  let buffer = '';
  return (chunk) => {
    buffer += chunk.replace(/\r\n/g, '\n');
    let end = buffer.indexOf('\n\n');
    while (end !== -1) {
      const block = buffer.slice(0, end);
      buffer = buffer.slice(end + 2);
      let event = 'message';
      const data: string[] = [];
      for (const line of block.split('\n')) {
        if (line.startsWith(':')) continue;
        const colon = line.indexOf(':');
        const field = colon === -1 ? line : line.slice(0, colon);
        const value = colon === -1 ? '' : line.slice(colon + 1).replace(/^ /, '');
        if (field === 'event') event = value;
        else if (field === 'data') data.push(value);
      }
      if (data.length > 0) onEvent({ event, data: data.join('\n') });
      end = buffer.indexOf('\n\n');
    }
  };
}
